<template>
	<v-dialog v-model="showDialog" :max-width="maxWidth">
		<v-card :tile="$vuetify.breakpoint.xs" id="card" class="large-process-dialog">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">{{ toolbarTitle }}</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-2">
				<ValidationError :errors="errors" />
				<v-sheet elevation="0" class="mt-4">
					<LargeProcessForm
						ref="form"
						:current_company_name="current_company_name"
						:large_process_types="largeProcessTypes"
						:large_process.sync="largeProcess"
						:requiredOrderIndividualInfo="requiredOrderIndividualInfo"
						:readonly="readonly"
						:disabled="disabled"
						:deleted_values.sync="deletedValues"
						:formType="'edit'"
						@submit-form="submitForm"
						@is-window-size-check="$emit('is-window-size-check', true)"
						@add-files="addFiles($event)"
					/>
					<v-divider class="my-4" />
					<v-row no-gutters justify="center">
						<!-- TODO 削除ボタンを機能させる 　作業時間があると削除不可 -->
						<TemplateDeleteDialog
							ref="deleteDialog"
							:openBtnColor="openBtnColor"
							:openBtnClass="openBtnClass"
						>
							<template v-slot:button>
								<v-btn class="ma-1" @click="isDeletable" dense dark color="red"> 削除する </v-btn>
							</template>
						</TemplateDeleteDialog>
					</v-row>
				</v-sheet>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import moment from "moment/min/moment.min.js"
import ValidationError from "../../shared/ValidationError.vue"
import LargeProcessForm from "./LargeProcessForm.vue"
import TemplateDeleteDialog from "../../shared/TemplateDeleteDialog.vue"

export default {
	props: {
		large_process: {
			type: null,
			required: false,
		},
		maxWidth: {
			type: String,
			default: "700px",
			required: false,
		},
		toolbarTitle: {
			type: String,
			default: "追加項目",
			required: false,
		},
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		readonly: {
			type: Boolean,
			required: false,
			default: false,
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		requireFetch: {
			type: Boolean,
			required: false,
			default: false,
		},
		large_process_types: {
			type: Array,
			required: false,
			default: () => [],
		},
		// order_individual_infos: {
		// 	type: Array,
		// 	required: false,
		// 	default: () => [],
		// },
		current_company_name: {
			type: String,
			required: false,
		},
		requiredOrderIndividualInfo: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
	components: {
		ValidationError,
		LargeProcessForm,
		TemplateDeleteDialog,
	},
	data() {
		return {
			rules: rules,
			id: null,
			common: common,
			valid: false,
			orderIndividualInfos: [],
			largeProcessTypes: [],
			largeProcess: {
				large_process_type_id: null,
				order_individual_info_id: null,
				start_date: null,
				end_date: null,
				start_time: null,
				end_time: null,
				planned_start_date: null,
				planned_end_date: null,
				planned_start_time: null,
				planned_end_time: null,
				schedule_start_date: null,
				schedule_end_date: null,
				schedule_start_time: null,
				schedule_end_time: null,
				memo: null,
				large_process_values_attributes: [],
			},
			deletedValues: [],
			errors: [],
			openBtnColor: "red",
			openBtnClass: "white--text",
			files: [],
		}
	},
	mounted() {
		if (!this.requireFetch) {
			this.largeProcessTypes = this.large_process_types
			// if (this.requiredIndividualInfo) {
			// 	this.orderIndividualInfos = this.order_individual_infos.map((o) => ({
			// 		id: o.id,
			// 		name: common.productNameWithProductNumber(o),
			// 	}))
			// }
			this.largeProcess = this.setProcess(this.large_process)
		}
	},
	methods: {
		addFiles(files) {
			this.files = files
		},
		closeDialog() {
			this.showDialog = false
			this.deletedValues = []
		},
		fetchProductAndProcess(id) {
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/large_processes/${id}/edit`, { headers })
				.then((res) => {
					this.largeProcessTypes = res.data.large_process_types
					this.largeProcess = this.setProcess(res.data.large_process)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		submitForm() {
			const headers = authenticate.setHeader()
			let formData = new FormData()

			let large_process = _.cloneDeep(this.largeProcess)
			large_process.large_process_values_attributes =
				large_process.large_process_values_attributes.concat(this.deletedValues)

			const largeProcessData = JSON.stringify(large_process)
			formData.set("large_process", largeProcessData)

			if (this.files.length) {
				this.files.forEach((file) => {
					formData.append(
						"files" + "[]",
						new Blob([file], {
							type: file.type,
						}),
						file.name
					)
				})
			}

			axios
				.put(`/erp/v1/large_processes/${this.largeProcess.id}`, formData, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "更新しました。",
					})
					this.$emit("update-large-process", res.data)
					this.closeDialog()
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		isDeletable() {
			// 工程開始日、工程開始時刻がある場合は削除不可
			if (this.largeProcess.start_date !== null && this.largeProcess.start_time !== null) {
				this.$store.dispatch("setFlash", {
					type: "alert",
					text: "すでに工程が開始されているため削除できません。",
				})
				this.$refs.deleteDialog.closeDialog()
			} else {
				this.deleteLargeProcess()
			}
		},
		deleteLargeProcess() {
			const headers = authenticate.setHeader()
			axios
				.delete(`/erp/v1/large_processes/${this.largeProcess.id}`, { headers })
				.then((res) => {
					if (res.status == 204) {
						this.$store.dispatch("setFlash", {
							type: "alert",
							text: "削除しました。",
						})
						this.$refs.deleteDialog.closeDialog()
						this.$emit("delete")
					}
				})
				.catch((err) => {
					if (Array.isArray(err.response.data)) {
						this.$store.dispatch("setFlash", {
							type: "alert",
							text: `${err.response.data}`,
						})
					}
				})
		},
		setProcess(largeProcess) {
			if (!largeProcess) {
				return {
					large_process_type_id: null,
					order_individual_info_id: null,
					start_date: null,
					end_date: null,
					start_time: null,
					end_time: null,
					planned_start_date: null,
					planned_end_date: null,
					planned_start_time: null,
					planned_end_time: null,
					schedule_start_date: null,
					schedule_end_date: null,
					schedule_start_time: null,
					schedule_end_time: null,
					memo: null,
					team_member_id: null,
					team_id: null,
					lock_flag: false,
					large_process_values_attributes: [],
				}
			}
			let newLargeProcess = _.cloneDeep(largeProcess)
			newLargeProcess.large_process_values_attributes = newLargeProcess.large_process_values.map(
				(v) => {
					if (v.value_time) {
						v.value_time = moment(v.value_time).format("HH:mm")
					}
					return v
				}
			)
			newLargeProcess.start_time = largeProcess.start_time
				? moment(largeProcess.start_time).format("HH:mm")
				: null
			newLargeProcess.end_time = largeProcess.end_time
				? moment(largeProcess.end_time).format("HH:mm")
				: null
			newLargeProcess.planned_start_time = largeProcess.planned_start_time
				? moment(largeProcess.planned_start_time).format("HH:mm")
				: null
			newLargeProcess.planned_end_time = largeProcess.planned_end_time
				? moment(largeProcess.planned_end_time).format("HH:mm")
				: null
			newLargeProcess.schedule_start_time = largeProcess.schedule_start_time
				? moment(largeProcess.schedule_start_time).format("HH:mm")
				: null
			newLargeProcess.schedule_end_time = largeProcess.schedule_end_time
				? moment(largeProcess.schedule_end_time).format("HH:mm")
				: null

			const existingColumnIds = newLargeProcess.large_process_values.map(
				(v) => v.large_process_column_id
			)
			const largeProcessType = this.largeProcessTypes.find(
				(t) => t.id == this.large_process.large_process_type_id
			)
			if (!largeProcessType) {
				delete newLargeProcess.large_process_values
				return newLargeProcess
			}
			const newColumns = largeProcessType.meta_keys.filter((v) => !existingColumnIds.includes(v.id))
			newColumns.forEach((m) => {
				let meta_value = { large_process_column_id: m.id }
				if (m.data_type == "target") {
					meta_value.value_target_id = null
					meta_value.value_target_type = null
				} else {
					meta_value[`value_${m.data_type}`] = null
				}
				this.largeProcess.large_process_values_attributes.push(meta_value)
			})
			delete newLargeProcess.large_process_values

			if (largeProcessType.schedule_arrangement_flag) {
				newLargeProcess.schedule_arrangement_attributes = {
					id: largeProcess.schedule_arrangement.id,
					estimated_start_date: largeProcess.schedule_arrangement.estimated_start_date
						? moment(largeProcess.schedule_arrangement.estimated_start_date).format("YYYY-MM-DD")
						: null,
					estimated_end_date: largeProcess.schedule_arrangement.estimated_end_date
						? moment(largeProcess.schedule_arrangement.estimated_end_date).format("YYYY-MM-DD")
						: null,
					planned_start_time: largeProcess.schedule_arrangement.planned_start_time
						? moment(largeProcess.schedule_arrangement.planned_start_time).format(
								"YYYY-MM-DD HH:mm"
						  )
						: null,
					planned_end_time: largeProcess.schedule_arrangement.planned_end_time
						? moment(largeProcess.schedule_arrangement.planned_end_time).format("YYYY-MM-DD HH:mm")
						: null,
				}
				delete newLargeProcess.schedule_arrangement
			}

			return newLargeProcess
		},
	},
	watch: {
		// order_individual_infos(newVal, _) {
		// 	this.orderIndividualInfos = newVal.map((o) => ({
		// 		id: o.id,
		// 		name: common.productNameWithProductNumber(o),
		// 	}))
		// 	console.log(this.orderIndividualInfos);
		// },
		large_process_types(newVal, _) {
			this.largeProcessTypes = newVal
		},
		order_individual_info(newVal, _) {
			this.largeProcess.order_individual_info_id = newVal
		},
		large_process(newVal, _) {
			if (this.requireFetch) {
				this.fetchProductAndProcess(newVal.id)
			} else {
				this.largeProcess = this.setProcess(newVal)
			}
		},
		deep: true,
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
}
</script>

<style lang="scss">
@import "../../../stylesheet/variable.scss";

.field-input {
	border: solid 1px #a8a8a8 !important;
	box-shadow: none !important;
}
.date-time-picker {
	@media (min-width: $xs) {
		width: 49.6% !important;
		margin-bottom: 20px !important;
	}
}
.fc-toolbar-title {
	@media (max-width: $xs) {
		font-size: 1.2em !important;
	}
}
.fc-button {
	@media (max-width: $xs) {
		font-size: 0.6em !important;
	}
}
</style>
